<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Information Technology
"
                   :links="[{title:'Home', url:'/'},{title:'Syllabus'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="13"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Syllabus</div>
          <TabView ref="tabview">
            <TabPanel header="UG (B.E.)">
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-y-5">
                <div class="flex inline-flex flex-col">
                  <h3 class="p-3 bg-pink-600 w-60 max-w-60 text-white rounded-t-lg font-semibold">Revised in 2019</h3>
                  <ul class="bg-white rounded-b-lg border border-gray-200 w-60 max-w-60 text-gray-600 text-sm font-medium">
                    <syllabus-list v-for="(list,index) in yr2019"
                                   :key="index"
                                   :list="list"
                                   :department="department">
                    </syllabus-list>
                  </ul>
                </div>
                <div class="flex inline-flex flex-col">
                  <h3 class="p-3 bg-pink-600 w-60 max-w-60 text-white rounded-t-lg font-semibold">Revised in 2015</h3>
                  <ul class="bg-white rounded-b-lg border border-gray-200 w-60 max-w-60 text-gray-600 text-sm font-medium">
                    <syllabus-list v-for="(list,index) in yr2015"
                                   :key="index"
                                   :list="list"
                                   :department="department">
                    </syllabus-list>
                  </ul>
                </div>
                <div class="flex inline-flex flex-col">
                  <h3 class="p-3 bg-pink-600 w-60 max-w-60 text-white rounded-t-lg font-semibold">Revised in 2012</h3>
                  <ul class="bg-white rounded-b-lg border border-gray-200 w-60 max-w-60 text-gray-600 text-sm font-medium">
                    <syllabus-list v-for="(list,index) in yr2012"
                                   :key="index"
                                   :list="list"
                                   :department="department">
                    </syllabus-list>
                  </ul>
                </div>
              </div>

            </TabPanel>
            <TabPanel header="PG (M.E.)">

            </TabPanel>
            <TabPanel header="Other Resources">
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-y-5">
                <div class="flex inline-flex flex-col">
                  <h3 class="p-3 bg-pink-600 w-60 max-w-60 text-white rounded-t-lg font-semibold text-center">
                    Honor's</h3>
                  <ul class="bg-white rounded-b-lg border border-gray-200 w-60 max-w-60 text-gray-600 text-sm font-medium">
                    <syllabus-list v-for="(list,index) in yr2021"
                                   :key="index"
                                   :list="list"
                                   :department="department">
                    </syllabus-list>
                  </ul>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/it/Sidebar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import KeyRecruiters from "@/components/KeyRecruiters";
import SyllabusList from "@/components/SyllabusList";

export default {
  name: "Syllabus",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel,
    SyllabusList
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      department: 'it',
      yr2019: [
        {
          year: 2019,
          file: 'SEIT_2019.pdf',
          title: 'Second Year (SE)'
        },
        {
          year: 2019,
          file: 'TEIT_2019.pdf',
          title: 'Third Year (TE)'
        },
      ],
      yr2015: [
        {
          year: 2015,
          file: 'SEIT_2015.pdf',
          title: 'Second Year (SE)'
        },
        {
          year: 2015,
          file: 'TEIT_2015.pdf',
          title: 'Third Year (TE)'
        },
        {
          year: 2015,
          file: 'BEIT_2015.pdf',
          title: 'Fourth Year (BE)'
        },
      ],
      yr2012: [
        {
          year: 2012,
          file: 'SEIT_2012SEIT_2012.pdf',
          title: 'Second Year (SE)'
        },
        {
          year: 2012,
          file: 'TEIT_2012.pdf',
          title: 'Third Year (TE)'
        },
        {
          year: 2012,
          file: 'BEIT_2012.pdf',
          title: 'Fourth Year (BE)'
        },
      ],
      yr2021: [
        {
          year: 2021,
          file: 'Rules and Regulations of Honors and Minors_17.02.2021.pdf',
          title: 'Rules and Regulations of Honors'
        },
        {
          year: 2021,
          file: 'AI_ML_Honor.pdf',
          title: ' AI & Machine Learning'
        },
        {
          year: 2021,
          file: 'Cyber security.pdf',
          title: 'Cyber Security'
        },
        {
          year: 2021,
          file: 'Data Science_06.04.2021.pdf',
          title: 'Data Science'
        },
        {
          year: 2021,
          file: 'IoT_Honor.pdf',
          title: 'Internet of Things'
        },
        {
          year: 2021,
          file: 'Virtual_and_Augumented_Reality_06.04.2021.pdf',
          title: 'Virtual Reality and Augmented Reality'
        },
      ],
    }
  },
  methods: {
    getResult(year) {

      const s = this.lists.filter(item => {
        return item.year === year
      });

      const result = JSON.parse(JSON.stringify(s))
      //console.log(result[0].files)
      return result[0].files;
    }
  }
}
</script>
<style lang="scss" scoped/>
